import {stats} from '@s-ui/js/lib/ua-parser'

// `(compatible; Googlebot/2.1; +http://www.google.com/bot.html)` appended to a phone UA is what
// Googlebot-smartphone sends, and `@s-ui/critical-css` reuses the same token for its extraction.
// `stats()` matches the bot first and reports `isMobile: false`, so `config.get('isMobile')` is
// false for it and every mobile-only branch renders its desktop variant. Two consequences, both
// invisible from a browser: Google indexes the desktop markup of a mobile-first site, and the
// critical CSS inlined on mobile is the one of the desktop tree, so every rule that only exists
// in the mobile branch is missing at first paint (measured: the 100px Home ad slot).
// Reading the device from the UA without that token fixes both. Googlebot-desktop and the bare
// `Googlebot/2.1 (+…)` form don't carry it and stay desktop; `bingbot` already parses as mobile,
// so this quirk is Google's alone.
const GOOGLEBOT_COMPATIBILITY_TOKEN = /\s*\(compatible;\s*Googlebot\/[^)]*\)/i

/**
 * `stats(userAgent)` with the device flags corrected for Googlebot-smartphone. `browserName` is
 * the one of the untouched UA, so a bot is still recognisable as a bot.
 */
export const getDeviceStats = userAgent => {
  // `stats` throws on an empty user agent, so this call also keeps the contract the direct
  // `stats(userAgent)` calls this helper replaced had — no empty-UA branch to add here.
  const parsedStats = stats(userAgent)
  const userAgentWithoutBotToken = userAgent.replace(GOOGLEBOT_COMPATIBILITY_TOKEN, '')

  if (userAgentWithoutBotToken === userAgent) return parsedStats

  const {isMobile, isTablet} = stats(userAgentWithoutBotToken)

  return {...parsedStats, isMobile, isTablet}
}
